import type { ITeam } from '../../../base/common/auth.js';
import { Event } from '../../../base/common/events.js';
import type { IIdentitiyService } from '../common/auth.js';

/** The standalone agent preview has no account session. */
export class AgentIdentityService implements IIdentitiyService {
    readonly onDidChange: Event<IIdentitiyService | null> = Event.None;
    readonly teams: readonly ITeam[] = [];

    get me() { return null; }
    get isLoggedIn() { return false; }
    get isLoginProcessRunning() { return false; }
    get userId() { return null; }
    get currentTeam() { return null; }
    setCurrentTeam(_team: ITeam | null): void { }
    ensureTeam() { return Promise.resolve(null); }
    getAccessToken(_orgId: string) { return Promise.resolve(null); }
    login() { return Promise.resolve(null); }
    logout() { return Promise.resolve(); }
}
